import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./Header.css";
import logo from "../Asset/Images/MFMP-logo-1.jpg";
import android from "../Asset/Images/android.png";
import apple from "../Asset/Images/iphone.png";
// RestaurantRegistrationForm and ReferRestaurant removed to avoid double modals
import "../Asset/Css/RestaurantRegistrationForm.css";

const Header = () => {
  const [prevScrollPos, setPrevScrollPos] = useState(window.scrollY);
  const [visible, setVisible] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // Modal states removed as they are handled by FristConten via routes

  const [activeSection, setActiveSection] = useState("home");

  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      setVisible(prevScrollPos > currentScrollPos || currentScrollPos < 10);
      if (prevScrollPos > currentScrollPos && isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
      }
      setPrevScrollPos(currentScrollPos);

      // Scroll Spy Logic
      const sections = ["home", "about-us", "how-it-works", "call-to-action", "testimonials"];
      let current = "";
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 200) {
            current = section;
          }
        }
      }
      if (current) {
        setActiveSection(current);
      } else if (currentScrollPos < 100) {
        setActiveSection("home");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [prevScrollPos, isMobileMenuOpen]);

  return (
    <>
      <nav
        className={`navbar navbar-expand-xl navbar-light fixed-top px-4 px-lg-5 ${visible ? "visible-navbar" : "hidden-navbar"
          }`}
      >
        <Link className="navbar-brand" to="/">
          <img src={logo} alt="Logo" style={{ height: "65px" }} />
        </Link>
        <button
          className="navbar-toggler me-3"
          type="button"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-controls="navbarNav"
          aria-expanded={isMobileMenuOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className={`collapse navbar-collapse ${isMobileMenuOpen ? "show" : ""
            }`}
          id="navbarNav"
        >
          <ul className="navbar-nav mx-auto align-items-center">
            <li className="nav-item">
              <Link
                className={`nav-link ${activeSection === "home" ? "active" : ""}`}
                to="#home"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveSection("home");
                  navigate("/");
                  setIsMobileMenuOpen(false);
                  setTimeout(() => {
                    const aboutSection = document.getElementById("home");
                    if (aboutSection) {
                      aboutSection.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }
                  }, 100);
                }}
              >
                HOME
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${activeSection === "about-us" ? "active" : ""}`}
                to="#about-us"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveSection("about-us");
                  navigate("/");
                  setTimeout(() => {
                    const aboutSection = document.getElementById("about-us");
                    if (aboutSection) {
                      aboutSection.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }
                  }, 100);
                }}
              >
                ABOUT US
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${activeSection === "how-it-works" ? "active" : ""}`}
                to="#how-it-works"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveSection("how-it-works");
                  navigate("/");
                  setTimeout(() => {
                    const howItWorksSection =
                      document.getElementById("how-it-works");
                    if (howItWorksSection) {
                      howItWorksSection.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }
                  }, 100);
                }}
              >
                HOW IT WORKS
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${activeSection === "call-to-action" ? "active" : ""}`}
                to="#call-to-action"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveSection("call-to-action");
                  navigate("/");
                  setTimeout(() => {
                    const howItWorksSection =
                      document.getElementById("call-to-action");
                    if (howItWorksSection) {
                      howItWorksSection.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }
                  }, 100);
                }}
              >
                MOBILE APPS
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${activeSection === "testimonials" ? "active" : ""}`}
                to="#testimonials"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveSection("testimonials");
                  navigate("/");
                  setTimeout(() => {
                    const howItWorksSection =
                      document.getElementById("testimonials");
                    if (howItWorksSection) {
                      howItWorksSection.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }
                  }, 100);
                }}
              >
                HOW TO
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link"
                to="https://franchise.myfoodmyprice.com/"
              >
                FRANCHISE
              </Link>
            </li>
            <li className="nav-item dropdown">
              <span
                className="nav-link dropdown-toggle"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ cursor: "pointer" }}
              >
                ENROLL
              </span>

              <ul className="dropdown-menu">
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      navigate("/enroll-restaurant");
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    ENROLL YOUR RESTAURANT
                  </button>
                </li>

                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      navigate("/refer-restaurant");
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    REFER YOUR FAVOURITE RESTAURANT
                  </button>
                </li>
              </ul>
            </li>

          </ul>
          <div className="d-flex flex-wrap flex-xl-nowrap align-items-center gap-3 mt-3 mt-xl-0 justify-content-center">
            <span className="btn-downloadtheapp text-nowrap">DOWNLOAD THE APP</span>
            <div className="header-divider d-none d-xl-block"></div>
            <div className="d-flex align-items-center gap-2">
              <a
                href="https://play.google.com/store/apps/details?id=com.biryanipalayam.myfoodmyprice&pli=1"
                target="_blank"
                rel="noopener noreferrer"
                className="icon-badge"
              >
                <img className="header-android-img" src={android} alt="Android" />
              </a>
              <a
                href="https://apps.apple.com/in/app/myfood-myprice/id6744266788"
                target="_blank"
                rel="noopener noreferrer"
                className="icon-badge"
              >
                <img className="header-android-img" src={apple} alt="Apple" />
              </a>
              <a
                href="https://wa.me/919994210404?text=Hi,%20I%20am%20interested%20to%20learn%20more%20about%20MyFoodMyPrice"
                className="icon-badge"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-whatsapp whatsapp-inner-icon"></i>
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Modals removed from Header.jsx. They are rendered in FristConten.jsx and triggered by routes. */}
    </>
  );
};

export default Header;
